import axios from 'axios';
import { NaverWorksError } from '../errors';
import qs from 'qs';
import { getQSObject } from '../utils/qsUtils';
// import {
//   NAVERWORKS_DRIVE_TYPE,
//   NAVERWORKS_FOLDER_TYPE_NAME,
//   NAVERWORKS_ROOT_FOLDER_NAME
// } from '../define/naverworksDefine';

// const UPLOAD_LOCAL_FOLDER_NAME = 'PolarisOffice_Edu';
const REQUEST_FILE_LIST_COUNT = 200;

function errorHandler(error) {
  if (error.isAxiosError && error.response) {
    throw new NaverWorksError(
      error.response?.data?.error?.message || error.response.statusText,
      error.response.status
    );
  } else {
    throw new NaverWorksError(error.message);
  }
}

// const NaverWorksBase = '/api/naverWorks';
const NaverWorksBase = '/api/v1/auth/naverWorks';

const NWApi = axios.create({
  baseURL: NaverWorksBase,
  paramsSerializer: (params) => {
    return qs.stringify(params);
  }
});

export async function getNaverWorksTokenInfo() {
  try {
    const res = await NWApi.post('/requestTokenInfo');
    return res.data;
  } catch (error) {
    errorHandler(error);
  }
}

export const getReauthorizationUrl = ({ domain }) =>
  `${NaverWorksBase}/reAuthorization?domain=${domain}&redirect_path=${encodeURIComponent(
    '/autoClose/index.html'
  )}`;

export async function reauthorizationNaverWorks({ domain, isSelf, redirectUrl }) {
  const query = getQSObject() || {};
  query['redirect_path'] = redirectUrl || location.pathname;
  const authURL = `${NaverWorksBase}/reAuthorization?domain=${domain}&${qs.stringify(query, {
    encode: true
  })}`;
  if (isSelf === true) location.href = authURL;
  else window.open(authURL, '_blank');
}

export async function getNaverWorksDriveInfo(type, id) {
  try {
    const params = { type, id };
    const result = await NWApi.get('/getDriveInfo', { params });
    return result.data;
  } catch (error) {
    errorHandler(error);
  }
}

export async function getNaverWorksShareDriveList() {
  try {
    const result = await NWApi.get('/getShareDriveList');
    return result.data;
  } catch (error) {
    errorHandler(error);
  }
}

export async function getNaverWorksGroupList() {
  try {
    const result = await NWApi.get('/getGroupList');
    return result.data;
  } catch (error) {
    errorHandler(error);
  }
}

export async function getNaverWorksRootFolder() {
  try {
    let fileList = [];
    let cursor = null;
    while (true) {
      const result = await NWApi.get('/getRootFolderList', {
        params: { orderBy: `modifiedTime desc`, count: REQUEST_FILE_LIST_COUNT, cursor }
      });
      fileList = [...fileList, ...result.data.data.files];
      cursor = result?.data?.responseMetaData?.nextCursor || null;
      if (!cursor) break;
    }

    return fileList;
  } catch (error) {
    errorHandler(error);
  }
}

export async function getNaverWorksFolderChildren(type, driveId, fileId) {
  try {
    let fileList = [];
    let cursor = null;
    while (true) {
      const result = await NWApi.get('/getFolderChildren', {
        params: {
          type,
          driveId,
          fileId,
          orderBy: `modifiedTime desc`,
          count: REQUEST_FILE_LIST_COUNT,
          cursor
        }
      });
      fileList = [...fileList, ...result.data.data.files];
      cursor = result?.data?.responseMetaData?.nextCursor || null;
      if (!cursor) break;
    }

    return fileList;
  } catch (error) {
    errorHandler(error);
  }
}

export async function getNaverWorksFile(type, driveId, fileId, isArrayBuffer = false) {
  try {
    const params = { type, driveId, fileId };
    const info = await NWApi.get('/getDocumentFile', { params });

    if (isArrayBuffer) {
      return {
        fileInfo: info.data.data.fileInfo,
        data: new Uint8Array(info.data.data.fileData.data)
      };
    }

    const copyed = new File(
      [new Blob([new Uint8Array(info.data.data.fileData.data)])],
      info.data.data.fileInfo.fileName
    );
    return { fileInfo: info.data.data.fileInfo, file: copyed };
  } catch (error) {
    errorHandler(error);
  }
}

export async function getNaverWorksFileRevision(type, driveId, fileId) {
  try {
    const params = { type, driveId, fileId };
    const result = await NWApi.get('/getDocumentFileRevisions', { params });
    return result.data;
  } catch (error) {
    errorHandler(error);
  }
}

// export async function getNaverWorksFileRestoreRevision() {
//   try {
//     const url = '/api/v1/auth/naverWorks/getDocumentFileRestoreRevision';
//     const info = await axios({
//       url,
//       method: 'post'
//     });

//     return info;
//   } catch (error) {
//     errorHandler(error);
//   }
// }

export async function updateNaverWorksFile({
  file,
  driveType,
  driveId,
  folderId,
  fileId,
  isLocal
}) {
  try {
    const formData = new FormData();
    formData.append('uploadFile', file);
    const reqUrl = isLocal
      ? '/updateLocalDocument'
      : `/updateDocument/${driveType}/${driveId}/${folderId}`;

    const res = await NWApi.post(reqUrl, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      maxContentLength: Infinity,
      maxBodyLength: Infinity
    });
    return res.data;
  } catch (error) {
    errorHandler(error);
  }
}

// export async function updateLocalFile(file) {
//   try {
//     const folderId = NAVERWORKS_ROOT_FOLDER_NAME;
//     const folderName = UPLOAD_LOCAL_FOLDER_NAME;
//     const res = await NWApi.post(`/getUploadLocalFolder`, {
//       folderName
//     });
//     return await updateNaverWorksFile(file, res.data.createFolderInfo.fileId, '');
//   } catch (error) {
//     errorHandler(error);
//   }
// }
